import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LyftState } from './lyft.reducer';

export const selectLyftState = createFeatureSelector<LyftState>('lyft');

export const getRideList = createSelector(selectLyftState, (state: LyftState) => ({
  rideList: state.rideList,
  lyftParams: state.lyftParams
}));

export const getRideDetails = createSelector(selectLyftState, (state: LyftState) => state.details);

export const getLyftParams = createSelector(selectLyftState, (state: LyftState) => ({
  ride: state.lyftParams.ride,
  pageIndex: state.lyftParams.pageIndex,
  pageSize: state.lyftParams.pageSize,
  search: state.lyftParams.search === '' ? null : state.lyftParams.search,
  filters: state.lyftParams.filters
}));

export const isLyftListLoading = createSelector(selectLyftState, (state: LyftState) => state.rideList.loading);
